import PageLayout from 'pages/Submissions/PageLayout';
import PageProvider from 'pages/Submissions/PageProvider';

const SubmissionsPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default SubmissionsPage;
